var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._g(_vm._b({staticClass:"btn-submit",attrs:{"type":"submit","variant":"primary","disabled":_vm.loading,"block":""}},'b-button',_vm.$attrs,false),_vm.$listeners),[(_vm.loading)?_c('b-spinner',{attrs:{"variant":"light","small":""}}):_c('span',[_vm._v(_vm._s(_vm.$tc('text', _vm.pluralization)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }